import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propFileField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { SaveButton } from "../../common/SaveButton";

export const SaleArticleDetailsImportDialog = (props: {
    close: () => void;
    onChange(): void;
}) => {
    const [useStore] = useState(() => createEntityStore<ImportParams>({
        data: { file: null },
        path: "articles/inventoryArticles/saleArticleDetailsImport",
        id: null,
        onSaved() {
            props.onChange();
            props.close();
        },
        propValidators: [
            propRequired("file"),
        ]
    }));

    const { save, isSaveDisabled } = useStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>Sales article details import</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={12}>{propFileField(useStore)("file", "CSV file")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <SaveButton save={save} disabled={isSaveDisabled} text="Import" />
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

interface ImportParams {
    file: File | null;
}
